import React from 'react'
import { Select } from 'antd'
import { GlobalOutlined } from '@ant-design/icons'
import { getLocaleLabel } from './locale-utils'

export interface LocaleSelectorProps {
    locales: string[]
    selectedLocale: string
    onLocaleChange: (locale: string) => void
}

const selectStyle = { minWidth: 200 }

/**
 * Dropdown component for selecting a catalog display locale.
 * Renders human-readable locale labels using Intl.DisplayNames
 * with a globe icon prefix.
 */
export const LocaleSelector: React.FC<LocaleSelectorProps> = ({ locales, selectedLocale, onLocaleChange }) => {
    return (
        <Select
            size="small"
            value={selectedLocale}
            onChange={onLocaleChange}
            style={selectStyle}
            prefix={<GlobalOutlined />}
            popupMatchSelectWidth={false}
            options={locales
                .map((locale) => ({
                    value: locale,
                    label: getLocaleLabel(locale),
                }))
                .sort((a, b) => String(a.label).localeCompare(String(b.label)))}
        />
    )
}
